import { render, staticRenderFns } from "./WikiText.vue?vue&type=template&id=80bdbe68"
import script from "./WikiText.vue?vue&type=script&lang=js"
export * from "./WikiText.vue?vue&type=script&lang=js"
import style0 from "./WikiText.vue?vue&type=style&index=0&id=80bdbe68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports